var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1939 3.40704H19.2559V28.4513H33.1939V3.40704Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1414 15.9292C20.1414 10.8407 22.5308 6.32744 26.2034 3.40709C23.5043 1.28319 20.0972 0 16.3804 0C7.57507 0 0.451172 7.12389 0.451172 15.9292C0.451172 24.7345 7.57507 31.8584 16.3804 31.8584C20.0972 31.8584 23.5043 30.5752 26.2034 28.4513C22.5308 25.5752 20.1414 21.0177 20.1414 15.9292Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0002 15.9292C52.0002 24.7345 44.8763 31.8584 36.071 31.8584C32.3542 31.8584 28.9472 30.5752 26.248 28.4513C29.9648 25.531 32.31 21.0177 32.31 15.9292C32.31 10.8407 29.9206 6.32744 26.248 3.40709C28.9472 1.28319 32.3542 0 36.071 0C44.8763 0 52.0002 7.16814 52.0002 15.9292Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.c113466086c9a2c0464fe632ada65a22.svg";
export { ForwardRef as ReactComponent };